import { render, staticRenderFns } from "./selectReasonAction.vue?vue&type=template&id=bb8fb89c&scoped=true"
import script from "./selectReasonAction.vue?vue&type=script&lang=js"
export * from "./selectReasonAction.vue?vue&type=script&lang=js"
import style0 from "./selectReasonAction.vue?vue&type=style&index=0&id=bb8fb89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8fb89c",
  null
  
)

export default component.exports